import { Static, String } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';

export const ProductCode = UnionEnum(['TPU', 'TPC', 'TMP']);
export type ProductCode = Static<typeof ProductCode>;

export const parseProductCode = (text: string): ProductCode | undefined =>
  ProductCode.enum.find(productCode => productCode === text);

export const AirportCode = String({ description: 'IATA Airport Code' });
export type AirportCode = Static<typeof AirportCode>;
